import React, { Component } from "react";

import "./Collapse.component.scss";

type CollapseType = {
    title: string;
    description: string;
    is_active: boolean;
};

type CollapseObject = {
    title: string;
    routes: CollapseType[];
    toggled: boolean;
    status: string;
};

export interface CollapseProps {
    items?: CollapseObject[];
    openMultiple?: boolean;
    handleCollapseChange?: any;
    toggleCollapse: any;
    header: any;
    open: boolean;
    collapse_id: number | string;
}

export default class Collapse extends Component<CollapseProps> {
    render() {
        return (
            <div className="collapse-container">
                <div className="collapse-object">
                    <div className="collapse-header-container">
                        <div className="collapse-header-object">
                            {this.props.header}
                        </div>
                    </div>
                    <div className="collapse-items-container">
                        <div
                            className={`collapse ${this.props.open && "show"}`}
                        >
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
